import { useEffect, useRef } from 'react';

export function useTripleSpaceToggle(onToggle: () => void) {
  const times = useRef<number[]>([]);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const el = e.target as HTMLElement | null;
      if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) {
        return;
      }

      if (e.code !== 'Space') return;

      e.preventDefault();

      const now = Date.now();
      times.current.push(now);
      if (times.current.length > 3) times.current.shift();

      const FAST_MS = 600;

      if (times.current.length === 3) {
        const [t1, t2, t3] = times.current;
        if (t3 - t1 <= 2 * FAST_MS && t2 - t1 <= FAST_MS && t3 - t2 <= FAST_MS) {
          onToggle();
          times.current = [];
        }
      }
    };

    window.addEventListener('keydown', handler, { passive: false });
    return () => window.removeEventListener('keydown', handler);
  }, [onToggle]);
}